import React from 'react';
import { black, blackblue, iconsData } from "./data";
import { ThemeContext } from '..';

export const SkillsIcons = () => {
    const darkMode = React.useContext(ThemeContext);
    return (
        <section className="section is-medium has-text-centered is-long" style={{ background: darkMode ? black : blackblue }} id="skills">

            <div className="title">Skills</div>

            <div className="container-3">
                <div className="cards">
                    {iconsData.map(item => {
                        return (
                            <div className="card" style={{ background: item.bg, width: "80px", padding: "10px", display: "flex", flexDirection: "column" }}>
                                <img src={`/img/${item.name}.svg`} alt={item.name} width="40px" height="auto" style={{ color: "white" }} />
                                <p style={{ fontSize: "10px", color: "white" }}>{item.name}</p>
                            </div>
                        )
                    })}
                </div>
            </div>
        </section>
    )
}